import styled from 'styled-components';
import * as colors from '../../../../common/colorConstants';

export const Container = styled.div`
  background-color: ${colors.lightGray7};
`;

export const Heading = styled.h4`
  font-weight: bold;
  margin-bottom: 20px;
`;

export const TimelineContainer = styled.div`
  position: relative;
  margin-left: 20px;
  padding-left: 10px;
`;

export const TimelineItem = styled.div`
  position: relative;
  margin-bottom: 40px;
  padding-left: 20px;
`;

export const CircleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Circle = styled.img`
  width: 14px;
  height: 14px;
  background-color: ${colors.lightGray1};
  border: 2px solid white;
  border-radius: 50%;
  position: absolute;
  left: -3px;
`;

export const Detail = styled.div`
  font-size: 14px;
  color: #333;
  margin-top: 6px;
`;

export const VerticalLine = styled.div`
  position: absolute;
  left: 14px;
  top: 44px;
  bottom: 0;
  width: 2px;
  background-color: ${colors.gray};
`;

export const OptionLabel = styled.div`
  font-weight: 500;
  margin-top: 6px;
  margin-left: 8px;
  font-size: 14px;
  color: #222;
  display: flex;
`;

export const CartList = styled.ul`
  list-style: none;
  padding-left: 16px;
  margin: 4px 0 8px;
`;

export const CartItem = styled.li`
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;

  span {
    font-style: italic;
  }
`;

export const CopyIcon = styled.img`
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
  user-select: none;
  color: #555;

  &:hover {
    color: #000;
  }
`;

export const CopiedText = styled.span`
  margin-left: 8px;
  font-size: 14px;
  color: green;
  font-weight: 500;
`;
